export enum RouteName {
  List = 'WF-merchant-payouts',
}
